import styled from "styled-components"
import {greys} from "@irati/ui/src/global/colors"

export default styled.div`
  border: 1px solid ${greys.mediumDark};
  border-radius: 3px;
  width: 130px;
  height: 40px;
  box-sizing: border-box;
  display: flex;
  user-select: none;
`
